<template>
    <div class="outer-authorized">
        <div class="middle ">
            <div class="inner">
                <div class="titles text-primary d-table text-center p-2">
                    <h3 class="d-table-cell align-middle">
                        <span class="text-uppercase" style="color:red"><strong>Acesso negado</strong></span><br />
                        <span class="small">Você não tem permissão para acessar esta tela! Favor entrar em contato com o Administrador do Sistema.</span>
                    </h3>
                </div>
                <div class="icon-bottom">
                    <i class="fa fa-6x fa-exclamation-circle icon-animated" style="font-size: 90px;color: #cc2213;"></i>
                </div>
                <div class="col-12" style="text-align:center">
                    <div class="form-group cna-login__group">
                        <a href="/home" class="btn btn-sm btn-default btn-default-app p-2 text-white">Ir para home</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    export default {
        name: 'acessonegado',
    }
</script>
